"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEditableColor = exports.lightGreen = exports.lightBlue = exports.grey = exports.lightGrey = void 0;
var colors_1 = require("@ant-design/colors");
exports.lightGrey = {
    backgroundOpacity: '#00000011',
    background: '#fafafa',
    border: '1px solid #f0f0f0',
    borderColor: '#f0f0f0'
};
exports.grey = {
    background: '#f5f5f5',
    border: '1px solid lightgray',
    borderColor: 'lightgray'
};
exports.lightBlue = {
    color: colors_1.blue.primary,
    background: '#e6f7ff',
    border: '1px solid #64b5f6',
    borderColor: '#64b5f6'
};
exports.lightGreen = {
    background: '#eefdec'
};
function getEditableColor() {
    return 'rgb(255, 248, 240, 0.6)';
}
exports.getEditableColor = getEditableColor;
//# sourceMappingURL=color.js.map